import {apiClient} from '@/shared/services/apiClient';
import type {OhdGoodhueIncentivesResponse, OhdOrganizationMetrics, OhdOrganizationListEntry} from '../types';

export class OhdService {
    static async getMetrics(ohdOrgId: number, campaignId?: number): Promise<OhdOrganizationMetrics> {
        const suffix = campaignId ? `?campaignId=${encodeURIComponent(campaignId)}` : '';
        return apiClient.get<OhdOrganizationMetrics>(`/api/admin/ohd/metrics/${ohdOrgId}${suffix}`);
    }

    static async listOrganizations(): Promise<OhdOrganizationListEntry[]> {
        const resp = await apiClient.get<{organizations: OhdOrganizationListEntry[]}>('/api/admin/ohd/organizations');
        return resp.organizations;
    }

    static async getMyIncentives(): Promise<OhdGoodhueIncentivesResponse> {
        return apiClient.get<OhdGoodhueIncentivesResponse>('/api/ohd/incentives/me');
    }
}
